'use client'

import { useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'
import { useUserStore } from '@/stores/useUserStore'
import { normalizePromoCode, PROMO_CODE_SESSION_STORAGE_KEY } from '@/utils/promoCode'

export default function PromoCodeListener() {
  const searchParams = useSearchParams()
  const promoCode = searchParams.get('promocode')
  const userId = useUserStore(state => state.userId)
  const previousUserId = useRef(userId)

  useEffect(() => {
    const loggedOut = previousUserId.current !== null && userId === null
    previousUserId.current = userId

    if (loggedOut) {
      sessionStorage.removeItem(PROMO_CODE_SESSION_STORAGE_KEY)
      return
    }

    if (promoCode) {
      const normalizedCode = normalizePromoCode(promoCode)
      if (normalizedCode) {
        sessionStorage.setItem(PROMO_CODE_SESSION_STORAGE_KEY, normalizedCode)
      }
    }
  }, [promoCode, userId])

  return null
}
